module.exports = __webpack_public_path__ + "img/alessandra.72c4efc0.png";